var $315984f57113734f$exports = {};
$315984f57113734f$exports = {
    "collectionLabel": `Javaslatok`
};


export {$315984f57113734f$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
